import React, { Component } from 'react';
import { computeUpgrade } from './UpgradePrompt';

// Shown on the Details step when the selection includes paid properties
// and no License Key has been entered (issue #71). Free registration is
// not offered here because a free key would not cover the selection.
// Instead it names the lowest plan that does and links to the pricing
// page, and lists the subscriptions the selection requires.
export class PaidPlanRequired extends Component {
    displayName = PaidPlanRequired.name;

    render() {
        // computeUpgrade with no held keys still resolves the lowest plan
        // that covers the whole selection.
        var upgrade = computeUpgrade(
            this.props.plans, this.props.selectedProperties, []);
        var required = upgrade ? upgrade.required : null;

        var pricingUrl = required && required.SignUpUrl &&
            required.SignUpUrl.indexOf('http') === 0
            ? required.SignUpUrl
            : 'https://51degrees.com/pricing';

        return (
            <article className="c-card c-card--highlight">
                <header className="c-card__header">
                    <h3 className="c-card__heading">
                        Your selection needs a paid plan
                    </h3>
                </header>
                <p>
                    You have selected paid properties, so a free License Key
                    will not cover them.
                    {required ? (
                        <span>
                            {' '}The lowest plan that covers your whole
                            selection is <strong>{required.Name}</strong>.
                        </span>
                    ) : null}
                    {' '}Get a License Key on the
                    {' '}<a href={pricingUrl} target="_blank"
                        rel="noopener noreferrer" className="b-link">
                        pricing page</a>, then paste it into the box above.
                </p>
                {this.props.requiredVendors &&
                    this.props.requiredVendors.length > 0 ? (
                    <p>
                        Required subscriptions:{' '}
                        {this.props.requiredVendors
                            .map(v => v.name).join(', ')}.
                    </p>
                ) : null}
            </article>
        );
    }
}
